import { OptionType } from '@evinced-private/ui-common';

import { GetUniqueIssuesFilterOptionsQuery } from '../UniqueIssuesFilterOptions.generated';

export interface IUniqueIssuesFilterOptions {
	severities: OptionType[];
	issueTypes: OptionType[];
}

const getDistinctValues = (values: string[]): string[] => {
	return Array.from(new Set(values));
};

const toSortedOptions = (values: string[]): OptionType[] => {
	return values
		.map((value) => ({
			value,
			label: value
		}))
		.slice()
		.sort((a, b) => a.label.localeCompare(b.label));
};

export const transformUniqueIssuesFilterOptions = (
	result: GetUniqueIssuesFilterOptionsQuery
): IUniqueIssuesFilterOptions => {
	const issues = result?.uniqueness_issues || [];

	const { severities: allSeverities, issueTypes: allIssueTypes } = issues.reduce<{
		severities: string[];
		issueTypes: string[];
	}>(
		(acc, issue) => {
			if (issue?.severity) {
				acc.severities.push(issue.severity);
			}
			if (issue?.issue_type) {
				acc.issueTypes.push(issue.issue_type);
			}
			return acc;
		},
		{ severities: [], issueTypes: [] }
	);

	const distinctSeverities = getDistinctValues(allSeverities);
	const distinctIssueTypes = getDistinctValues(allIssueTypes);

	return {
		severities: toSortedOptions(distinctSeverities),
		issueTypes: toSortedOptions(distinctIssueTypes)
	};
};
